<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">套餐管理</h4>
            </div>
            <div class="ml-auto">
              <div>
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="modals1 = true"
                  >查看激活码</base-button
                >
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="default"
                  @click="hangleCreateCdk"
                  >生成激活码</base-button
                >
                <base-button
                  style="margin-right: 30px"
                  size="sm"
                  type="success"
                  @click="handCreateUser"
                  >生成账号密码</base-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-primary mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>

                <el-select
                  class="select-danger"
                  style="width: 200px; margin-left: 10px"
                  placeholder="请选择"
                  v-model="adminSelects.simple"
                  @change="handleSelectsChange"
                >
                  <el-option
                    v-for="option in adminSelects.languages"
                    class="select-danger"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>

              <base-input>
                <el-input
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索激活码"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="id" prop="id" :min-width="60">
              </el-table-column>
              <el-table-column label="卡密" prop="cdk" :min-width="180">
              </el-table-column>
              <el-table-column label="套餐名称" prop="name" :min-width="110">
              </el-table-column>
              <el-table-column
                label="套餐类型"
                prop="package_type"
                :min-width="90"
              >
                <template slot-scope="{ row }">
                  <badge v-if="row.package_type === 1" type="default"
                    >时间套餐</badge
                  >
                  <badge v-if="row.package_type === 2" type="default"
                    >次数套餐</badge
                  >
                  <badge v-if="row.package_type === 3" type="default"
                    >积分套餐</badge
                  >
                </template>
              </el-table-column>
              <el-table-column label="激活用户" prop="username" :min-width="80">
              </el-table-column>
              <el-table-column
                label="生成者"
                prop="admin_username"
                :min-width="80"
              >
              </el-table-column>
              <el-table-column
                label="使用时间"
                prop="use_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>
              <el-table-column
                label="生成时间"
                prop="add_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>
              <el-table-column label="卡密状态" prop="state" :min-width="80">
                <template slot-scope="{ row }">
                  <badge v-if="row.state === 0" type="success">未使用</badge>
                  <badge v-if="row.state === 2" type="default">已退卡</badge>
                  <badge v-if="row.state === 1" type="danger">已使用</badge>
                </template>
              </el-table-column>

              <!-- <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column> -->
              <el-table-column :min-width="60" align="right" label="操作">
                <div slot-scope="props">
                  <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>
    <div>
      <modal :show.sync="modals" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">生成激活码</h4>
        <div>选择管理员</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择管理员"
            v-model="selects1.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects1.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 8px">选择套餐</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择套餐"
            v-model="selects.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>

        <div style="margin-top: 8px">选择生成类型</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择生成类型"
            v-model="creatCdkSelects.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in creatCdkSelects.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>
        <base-input
          style="margin-top: 8px"
          label="生成数量"
          type="text"
          placeholder="请输入生成数量"
          v-model="num"
        ></base-input>
        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="doCreateCdk">确定</base-button>
          <base-button type="danger" @click.native="modals = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>

    <div>
      <modal :show.sync="modals4" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">生成账号密码</h4>
        <base-input
          style="margin-top: 8px"
          label="生成数量"
          type="text"
          placeholder="请输入生成数量"
          v-model="createUserNum"
        ></base-input>
        <div>选择管理员</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择管理员"
            v-model="selects1.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects1.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="doHandCreateUser">确定</base-button>
          <base-button type="danger" @click.native="modals4 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>

    <div >
      <modal :show.sync="modals1" headerClasses="justify-content-center" class="custom-modal">
        <h4 slot="header" class="title title-up" >激活码({{ cdknum }}个)</h4>
        <div>
          <!-- <div>生成激活码数量 {{ cdknum }} 个</div> -->
          <base-input style="padding: 0" >
            <textarea
              ref="myTextarea"
              v-model="myTextareaValue"
              style="
                padding: 0;
                height: 400px !important;
                max-height: 400px !important;
              "
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </base-input>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <base-button
            type="secondary"
            @click="modals1 = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="modals1 = false"
            >确认</base-button
          >
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";

export default {
  components: {
    Modal,
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      //   let result = this.tableData;
      //   if (this.searchedData.length > 0) {
      //     result = this.searchedData;
      //   }
      //   console.log(result.slice(this.from, this.to));
      //   return result.slice(this.from, this.to);
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      //   console.log("to---"+highBound);
      return highBound;
    },
    from() {
      //   console.log("from---",this.pagination.perPage * (this.pagination.currentPage - 1));
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      modals: false,
      modals1: false,
      modals4: false,
      cdknum: 0,
      num: "",
      createUserNum: "",
      myTextareaValue: "",
      selects: {
        simple: "",
        languages: [],
      },
      selects1: {
        simple: "",
        languages: [],
      },
      adminSelects: {
        simple: "0",
        languages: [{ value: "0", label: "全部管理员" }],
      },
     creatCdkSelects: {
        simple: "",
        languages: [{ value: "0", label: "账号和激活码" },{ value: "1", label: "激活码" }],
      },
    };
  },
  methods: {
    // 单选框选择事件
    handleSelectsChange(value) {
      // console.log("当前选择的值:", value);
      localStorage.setItem("userInfoSelectStoreId", value);
      this.handleCurrentChange();
    },
    doCreateCdk() {
      http
        .post(
          "/v1/admin/createCdk",
          {
            packageId: this.selects.simple,
            adminId: this.selects1.simple,
            creatType: this.creatCdkSelects.simple,
            num: this.num,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });

          let textareaValue = "";
          res.data.data.forEach((element) => {
            textareaValue += element + "\n";
          });
          this.myTextareaValue = textareaValue;
          this.cdknum = res.data.data.length;
          this.handleCurrentChange();
          this.modals = false;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    handCreateUser() {
      this.createUserNum = "";
      this.modals4 = true;
    },
    doHandCreateUser() {
      http
        .post(
          "/v1/admin/createUser",
          {
            num: this.createUserNum,
            adminId: this.selects1.simple,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });

          let textareaValue = "";
          res.data.data.forEach((element) => {
            textareaValue += element + "\n";
          });
          this.myTextareaValue = textareaValue;
          this.cdknum = res.data.data.length;
          this.handleCurrentChange();
          this.modals4 = false;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    hangleCreateCdk() {
      http
        .get("/v1/admin/getAllPackage", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          let siteDataArr = [];
          res.data.data.packageData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.num = "";
          this.selects.languages = siteDataArr;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
      this.modals = true;
    },
    onBlur() {
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    handleCurrentChange() {
      let userInfoSelectStoreId = localStorage.getItem("userInfoSelectStoreId");
      if (userInfoSelectStoreId) {
        this.adminSelects.simple = userInfoSelectStoreId;
      } else {
        this.adminSelects.simple = "0";
        localStorage.setItem("userInfoSelectStoreId", "0");
        userInfoSelectStoreId = "0";
      }

      http
        .post(
          "/v1/admin/getAllCdk",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
            adminId: userInfoSelectStoreId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.tableData;

          this.adminSelects.languages = [{ value: "0", label: "全部管理员" }];
          res.data.data.adminData.forEach((element) => {
            let storeData = {
              value: String(element.id),
              label: element.username,
            };
            this.adminSelects.languages.push(storeData);
          });

          let adminDataArr = [];
          res.data.data.adminData.forEach((element) => {
            adminDataArr.push({
              value: element.id,
              label: element.username,
            });
          });
          this.selects1.languages = adminDataArr;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
    handleDelete(index, row) {
      Swal.fire({
        title: "停用激活码",
        text: `确定要停用该激活码吗?`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          http
            .post(
              "/v1/admin/deleteCdk",
              {
                cdkId: row.id,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  title: "停用激活码失败！！！",
                  text: res.data.message,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              this.handleCurrentChange();
              Swal.fire({
                title: "激活码退卡成功",
                text: res.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              console.error("发生错误:", error);
            });
        }
      });
    },
  },
  mounted() {
    this.handleCurrentChange();
  },
  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}

.custom-modal .modal-dialog {
  max-width: 600px !important; /* 覆盖全局样式 */
}
</style>
